/* ==========================================================================
   LFKY — comportements du thème
   Vanilla JS, aucune dépendance. Respecte prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = document.documentElement.classList.contains('reduce-motion');
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function formatMoney(cents) {
    var fmt = (window.LFKY && window.LFKY.moneyFormat) || '{{amount}}';
    var amount = (cents / 100).toFixed(2);
    if (fmt.indexOf('amount_with_comma_separator') > -1 || fmt.indexOf('{{amount}}') === -1) {
      amount = amount.replace('.', ',');
    }
    if (fmt.indexOf('{{') === -1) return amount;
    return fmt.replace(/\{\{\s*amount(_with_comma_separator|_no_decimals|_with_space_separator)?\s*\}\}/, amount);
  }

  /* ---------------------------------------------------------------- Overlay */
  var overlay = $('[data-overlay]');
  var openPanels = [];

  function lockScroll(on) {
    document.body.style.overflow = on ? 'hidden' : '';
  }

  function openPanel(el) {
    if (!el || openPanels.indexOf(el) > -1) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    openPanels.push(el);
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-visible'); }); }
    lockScroll(true);
    var focusable = el.querySelector('button, [href], input, select, textarea');
    if (focusable) focusable.focus({ preventScroll: true });
  }

  function closePanel(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    openPanels = openPanels.filter(function (p) { return p !== el; });
    if (!openPanels.length) {
      if (overlay) {
        overlay.classList.remove('is-visible');
        setTimeout(function () { if (!openPanels.length) overlay.hidden = true; }, 450);
      }
      lockScroll(false);
    }
  }

  function closeAll() { openPanels.slice().forEach(closePanel); }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-open]');
    if (openBtn) { e.preventDefault(); openPanel($('#' + openBtn.getAttribute('data-open'))); return; }
    var closeBtn = e.target.closest('[data-close]');
    if (closeBtn) { e.preventDefault(); closePanel(closeBtn.closest('.drawer')); return; }
    if (e.target === overlay) closeAll();
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ----------------------------------------------------------- En-tête auto */
  var header = $('[data-header]');
  if (header) {
    var lastY = window.scrollY;
    var ticking = false;
    var onScroll = function () {
      var y = window.scrollY;
      header.classList.toggle('is-stuck', y > 8);
      if (y > 260 && y > lastY + 4) header.classList.add('is-hidden');
      else if (y < lastY - 4 || y < 160) header.classList.remove('is-hidden');
      lastY = y;
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
    }, { passive: true });
    onScroll();
  }

  /* --------------------------------------------------------- Révélations */
  function initReveals(root) {
    var items = $$('.reveal, .zoom-in', root || document);
    if (!items.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ----------------------------------------------------- Bandeaux défilants */
  function initMarquees(root) {
    $$('[data-marquee]', root || document).forEach(function (m) {
      if (m.dataset.cloned === 'true') return;
      var track = $('.marquee__track, .announcement__track', m);
      var group = track && track.firstElementChild;
      if (!track || !group) return;
      track.appendChild(group.cloneNode(true));
      m.dataset.cloned = 'true';
    });
  }

  /* ------------------------------------------------------- Galerie produit */
  function initGallery(root) {
    $$('[data-gallery]', root || document).forEach(function (gal) {
      if (gal.dataset.ready === 'true') return;
      gal.dataset.ready = 'true';

      gal.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-goto]');
        if (!thumb) return;
        showSlide(gal, thumb.getAttribute('data-goto'));
      });
    });
  }

  function showSlide(gal, mediaId) {
    var slide = $('[data-media-id="' + mediaId + '"]', gal);
    if (!slide) return;
    $$('.gallery__slide', gal).forEach(function (s) { s.classList.toggle('is-active', s === slide); });
    $$('[data-goto]', gal).forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-goto') === String(mediaId));
    });
  }

  /* ------------------------------------------- Sélection de variante produit */
  function initProductForms(root) {
    $$('[data-product-root]', root || document).forEach(function (rootEl) {
      if (rootEl.dataset.ready === 'true') return;
      rootEl.dataset.ready = 'true';

      var dataEl = $('[data-variants-json]', rootEl);
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var form = $('form[data-product-form]', rootEl);
      var idInput = $('[data-variant-id]', rootEl);
      var submitBtn = $('[data-submit]', rootEl);
      var priceEl = $('[data-price]', rootEl);
      var compareEl = $('[data-compare-price]', rootEl);
      var stickyPrice = $('[data-sticky-price]');
      var gallery = $('[data-gallery]', rootEl);
      var optionCount = parseInt(rootEl.getAttribute('data-option-count'), 10) || 1;

      function selectedOptions() {
        var out = [];
        for (var i = 1; i <= optionCount; i++) {
          var checked = $('input[name="option' + i + '"]:checked', rootEl);
          out.push(checked ? checked.value : null);
        }
        return out;
      }

      function findVariant(opts) {
        return variants.filter(function (v) {
          return opts.every(function (o, i) { return o === null || v.options[i] === o; });
        })[0] || null;
      }

      // Grise les tailles indisponibles pour le coloris choisi
      function refreshAvailability() {
        var opts = selectedOptions();
        if (optionCount < 2) return;
        $$('input[name="option2"]', rootEl).forEach(function (input) {
          var candidate = findVariant([opts[0], input.value]);
          var ok = !!candidate && (candidate.available || candidate.preorder);
          input.disabled = !ok;
          var label = input.closest('.size');
          if (label) label.title = ok ? '' : (window.LFKY.strings.soldOut || '');
        });
      }

      function refreshLabels() {
        $$('[data-option-display]', rootEl).forEach(function (el) {
          var idx = el.getAttribute('data-option-display');
          var checked = $('input[name="option' + idx + '"]:checked', rootEl);
          el.textContent = checked ? checked.value : '';
        });
      }

      function update() {
        refreshAvailability();
        refreshLabels();
        var variant = findVariant(selectedOptions());

        if (!variant) {
          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = window.LFKY.strings.selectSize;
          }
          return;
        }

        if (idInput) idInput.value = variant.id;

        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.hidden = false;
            if (priceEl) priceEl.classList.add('price--sale');
          } else {
            compareEl.hidden = true;
            if (priceEl) priceEl.classList.remove('price--sale');
          }
        }
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

        // Le bandeau « fait à la commande » ne concerne que les coloris sans stock :
        // il doit disparaître dès qu'on sélectionne un coloris tenu en stock.
        $$('[data-preorder-banner], [data-preorder-badge]').forEach(function (el) {
          el.hidden = !variant.preorder;
        });

        if (submitBtn) {
          var buyable = variant.available || variant.preorder;
          submitBtn.disabled = !buyable;
          submitBtn.textContent = !buyable
            ? window.LFKY.strings.soldOut
            : (variant.preorder ? window.LFKY.strings.preorder : window.LFKY.strings.addToCart);
        }

        // Change l'URL sans recharger
        if (history.replaceState && variant.id) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }

        // Saute à l'image du coloris
        if (gallery && variant.featured_media_id) {
          showSlide(gallery, variant.featured_media_id);
        }
      }

      rootEl.addEventListener('change', function (e) {
        if (e.target.matches('input[name^="option"]')) update();
      });

      update();
    });
  }

  /* ------------------------------------------------------------- Quantité */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = $('input', wrap);
    var step = btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.min, 10) || 1;
    input.value = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* --------------------------------------------------------- Panier (AJAX) */
  var cartDrawer = $('#CartDrawer');

  function refreshCart() {
    // ?section_id=cart-drawer renvoie uniquement la section (enveloppée par
    // Shopify dans <div class="shopify-section">), pas le layout.
    return fetch(window.LFKY.routes.cart + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var container = $('[data-cart-contents]');
        if (!container) return;
        container.innerHTML = html;

        // Le compteur rendu dans la section fait foi.
        var source = container.querySelector('[data-cart-count]');
        var count = source ? source.textContent.trim() : '0';
        $$('[data-cart-count]').forEach(function (el) {
          if (container.contains(el)) return;
          el.textContent = count;
          el.hidden = count === '0' || count === '';
        });

        initReveals(container);
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var btn = $('[data-submit]', form) || $('[type="submit"]', form);
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }

    fetch(window.LFKY.routes.cart_add, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message);
        return refreshCart();
      })
      .then(function () { openPanel(cartDrawer); })
      .catch(function (err) {
        var msg = $('[data-form-error]', form);
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = original; }
      });
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (!remove) return;
    e.preventDefault();
    changeLine(remove.getAttribute('data-cart-remove'), 0);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-cart-qty'), parseInt(input.value, 10) || 0);
  });

  function changeLine(key, quantity) {
    fetch(window.LFKY.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function () { return refreshCart(); })
      .then(function () {
        if (document.body.classList.contains('template--cart')) window.location.reload();
      });
  }

  /* -------------------------------------------------- Barre d'achat mobile */
  var sticky = $('[data-sticky-atc]');
  if (sticky) {
    var anchor = $('[data-atc-anchor]');
    if (anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(anchor);
    }
    $('[data-sticky-buy]', sticky) && $('[data-sticky-buy]', sticky).addEventListener('click', function () {
      var form = $('form[data-product-form]');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }

  /* ------------------------------------------------- Compte à rebours */
  var RING = 2 * Math.PI * 56;
  var countdownTimer = null;

  function setDigit(el, value) {
    if (!el) return;
    var next = value < 10 ? '0' + value : String(value);
    if (el.textContent === next) return;
    el.textContent = next;
    if (reduced) return;
    el.classList.remove('is-tick');
    void el.offsetWidth;
    el.classList.add('is-tick');
  }

  function renderCountdown(root) {
    var target = Date.parse(root.getAttribute('data-target'));
    if (isNaN(target)) return true;

    var live = $('[data-cd-live]', root);
    var done = $('[data-cd-done]', root);
    var left = target - Date.now();

    if (left <= 0) {
      if (live) live.hidden = true;
      if (done) done.hidden = false;
      root.setAttribute('data-state', 'open');
      return true;
    }

    if (live) live.hidden = false;
    if (done) done.hidden = true;

    var total = Math.floor(left / 1000);
    var days = Math.floor(total / 86400);
    var hours = Math.floor((total % 86400) / 3600);
    var minutes = Math.floor((total % 3600) / 60);
    var seconds = total % 60;

    setDigit($('[data-cd="days"]', root), days);
    setDigit($('[data-cd="hours"]', root), hours);
    setDigit($('[data-cd="minutes"]', root), minutes);
    setDigit($('[data-cd="seconds"]', root), seconds);

    var ring = $('[data-cd-ring]', root);
    if (ring) {
      var start = Date.parse(root.getAttribute('data-opens-from'));
      if (isNaN(start)) start = target - 14 * 86400000;
      var span = target - start;
      var ratio = span > 0 ? 1 - left / span : 0;
      ratio = Math.max(0, Math.min(1, ratio));
      ring.style.strokeDashoffset = (RING * (1 - ratio)).toFixed(2);
    }

    // Lecteurs d'écran : une annonce par minute suffit, pas une par seconde.
    var say = $('[data-cd-announce]', root);
    if (say && seconds === 0) {
      say.textContent = days + ' j ' + hours + ' h ' + minutes + ' min avant l’ouverture.';
    }
    return false;
  }

  function initCountdowns(scope) {
    var roots = $$('[data-countdown-root]', scope);
    if (!roots.length) return;

    roots.forEach(function (root) { renderCountdown(root); });

    if (countdownTimer) return;
    countdownTimer = setInterval(function () {
      var all = $$('[data-countdown-root]');
      if (!all.length) { clearInterval(countdownTimer); countdownTimer = null; return; }
      all.forEach(function (root) { renderCountdown(root); });
    }, 1000);
  }

  // Au retour d'onglet, l'intervalle a pu dériver : on resynchronise.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) initCountdowns();
  });

  /* ---------------------------------------- Rechargement dans l'éditeur Shopify */
  document.addEventListener('shopify:section:load', function (e) {
    initReveals(e.target);
    initMarquees(e.target);
    initGallery(e.target);
    initProductForms(e.target);
    initCountdowns(e.target);
  });

  /* ------------------------------------------------------------------ Boot */
  function boot() {
    initReveals();
    initMarquees();
    initGallery();
    initProductForms();
    initCountdowns();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
